
import { Component, Prop, Vue } from 'vue-property-decorator';
import SingleImageUpload from '@/components/SingleImageUpload/index.vue';
import BindChargeLevel from '@/components/Recharge/level.vue';
@Component({
  components: { SingleImageUpload, BindChargeLevel },
})
export default class extends Vue {
  @Prop() model: any;
  @Prop() descModel: any;
  route = 'route';
  switchModel = [
    {
      value: true,
      lable: '开启',
    },
    {
      value: false,
      lable: '关闭',
    },
  ];
  stateModel = [
    {
      value: 'route',
      lable: 'APP内部',
    },
    {
      value: 'link',
      lable: '跳转连接',
    },
  ];
  appModel = [
    {
      value: '-1',
      lable: '请选择',
    },
    {
      value: 'coin',
      lable: '云币充值',
    },
    {
      value: 'card',
      lable: '周期卡充值',
    },
    {
      value: '/promoter',
      lable: '推广员',
    },
    {
      value: '/share',
      lable: '领云币',
    },
    {
      value: '/wellness_centers',
      lable: '领福利',
    },
  ];

  appModelChange() {
    // console.log('收到AppID变化: ', this.model.appid);
    if (this.model.appid === 'coin') {
      this.$emit('changeGradeType', 1);
    } else if (this.model.appid === 'card') {
      this.$emit('changeGradeType', 2);
    } else {
      this.$emit('changeGradeType', -1);
    }
  }
}
